export default __webpack_public_path__ + "static/media/instagram-grey.081b7df9.svg";